import React, { useState } from 'react'
import Button from 'transfix-ui/components/Button'
import { TableCell, TableRow } from 'transfix-ui/components/Table'
import { IConfigGroupMapping } from 'types/graphqlTypes'
import { EdiConfigGroupMappingForm } from './forms/EdiConfigGroupMappingForm'
import { TEdiConfigGroupMappingSchema } from './forms/EdiConfigGroupMappingSchema'

interface IEdiConfigGroupMappingTableRowProps {
  configGroupMapping: IConfigGroupMapping
  onSubmit: (formParams: TEdiConfigGroupMappingSchema) => void
}

export function EdiConfigGroupMappingTableRow({
  configGroupMapping,
  onSubmit,
}: IEdiConfigGroupMappingTableRowProps) {
  const [isEditing, setIsEditing] = useState<boolean>(false)

  const submitSuccessHandler = (formParams: TEdiConfigGroupMappingSchema) => {
    onSubmit(formParams)
    setIsEditing(false)
  }

  const startEditingHandler = () => setIsEditing(true)
  const cancelEditingHandler = () => setIsEditing(false)

  return (
    <TableRow>
      {isEditing ? (
        <TableCell colSpan={3}>
          <EdiConfigGroupMappingForm
            configGroupMapping={configGroupMapping}
            connectionConfigId={configGroupMapping.inboundEdiMapperConnectionConfigId}
            onCancel={cancelEditingHandler}
            onSubmitSuccess={submitSuccessHandler}
            shipperName={configGroupMapping.configGroup?.shipperApplication?.name}
          />
        </TableCell>
      ) : (
        <>
          <TableCell>{configGroupMapping?.configGroup?.name || ''}</TableCell>
          <TableCell>{configGroupMapping.isaSenderId}</TableCell>
          <TableCell>
            <Button onClick={startEditingHandler}>edit</Button>
          </TableCell>
        </>
      )}
    </TableRow>
  )
}
